import React from 'react';
import { Box, Typography } from '@mui/material';
import { Modal } from '@cmhc-schl/hearth-ui';

type ErrorStatusModalProps = {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  title: string;
  introText: string;
  proceedText: string;
  cancelText: string;
};

const ErrorStatusModal: React.FC<ErrorStatusModalProps> = ({
  open,
  onClose,
  onProceed,
  title,
  introText,
  proceedText,
  cancelText
}) => {
  return (
    <Modal
      id="statusChangeConfirmModal"
      isActive={open}
      onDismissalCallback={onClose}
      title={{ value: title }}
      bodyContent={
        <Box
          sx={{
            maxWidth: 576,
            width: '100%',
            borderRadius: 1,
            overflow: 'hidden'
          }}
        >
          <Typography variant="body2" sx={{ mb: 2 }}>
            {introText}
          </Typography>
        </Box>
      }
      modalButtons={{
        primaryButton: {
          name: 'proceed',
          text: { value: proceedText },
          ariaText: { value: proceedText },
          onClick: onProceed
        },
        secondaryButton: {
          name: 'cancel',
          text: { value: cancelText },
          ariaText: { value: cancelText },
          onClick: onClose
        }
      }}
      shouldCloseOnBackgroundClick={true}
    />
  );
};

export default ErrorStatusModal;
